import APIS from "../../constant/EndPoint";
import NACell from "../Reusable/DataTable/NACell";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import DataTable from "../Reusable/DataTable";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate, useSearchParams } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";
import { useSessionStorage } from "@uidotdev/usehooks";
import { useCallback, useEffect, useState } from "react";
import { hasValues } from "../../utils/hasValues";
import { useForm } from "react-hook-form";
import Card from "../Reusable/Card";
import RolesFilter from "./RolesFilter";
import { getKey } from "../../helpers/sessionKey";

interface IFilterCombobox {
  id: string;
  name: string;
  [key: string]: any;
}
export interface IFilterRoles {
  roles: IFilterCombobox | null;
  user_type: {
    id: string;
    name: string;
  } | null;
}
const UserList = (props: any) => {
  const { handleIsActive, handleIsSuperUser, handleIsStaff, handleIsRider } =
    props;
  const [searchParams, setSearchParms] = useSearchParams();

  const [localState, handleSetState] = useSessionStorage<IFilterRoles>(
    "order-filter-roles",
    {
      roles: null,
      user_type: null,
    }
  );

  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));

  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<IFilterRoles>({});
  const handleFilterReset = () => {
    reset({
      roles: null,
      user_type: null,
    });
  };
  const navigate = useNavigate();
  const canEditUser = usePermission({
    allowedPermissions: ["can_update_user"],
  });
  const handleRowClick = (row: any) => {
    if (!canEditUser) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const clientType = getKey("client-type");

  const defaultCargoColumns: any = [
    {
      header: "Full Name",
      accessorKey: "profile.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Username",
      accessorKey: "username",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    {
      header: "Branch",
      accessorKey: "default_branch.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_user"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Staff",
      accessorKey: "is_staff",
      cell: ({ row, getValue }) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <AccessControl
              children={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={false}
                  onChange={handleIsStaff}
                />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={true}
                  onChange={handleIsStaff}
                />
              }
            />
          </div>
        );
      },
    },
    // {
    //   header: "Rider Login",
    //   accessorKey: "is_rider",
    //   cell: ({ row, getValue }) => {
    //     return (
    //       <div onClick={(e) => e.stopPropagation()}>
    //         <AccessControl
    //           children={
    //             <SwitchButton
    //               id={row?.original?.id}
    //               value={getValue()}
    //               disabled={false}
    //               onChange={handleIsRider}
    //             />
    //           }
    //           allowedPermissions={["can_update_user"]}
    //           renderNoAccess={
    //             <SwitchButton
    //               id={row?.original?.id}
    //               value={getValue()}
    //               disabled={true}
    //               onChange={handleIsRider}
    //             />
    //           }
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      header: "Superuser",
      accessorKey: "is_superuser",
      cell: ({ row, getValue }) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <AccessControl
              children={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={false}
                  onChange={handleIsSuperUser}
                />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={true}
                  onChange={handleIsSuperUser}
                />
              }
            />
          </div>
        );
      },
    },
  ];

  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "profile.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Username",
      accessorKey: "username",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    {
      header: "Branch",
      accessorKey: "default_branch.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_user"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Staff",
      accessorKey: "is_staff",
      cell: ({ row, getValue }) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <AccessControl
              children={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={false}
                  onChange={handleIsStaff}
                />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={true}
                  onChange={handleIsStaff}
                />
              }
            />
          </div>
        );
      },
    },
    {
      header: "Rider Login",
      accessorKey: "is_rider",
      cell: ({ row, getValue }) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <AccessControl
              children={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={false}
                  onChange={handleIsRider}
                />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={true}
                  onChange={handleIsRider}
                />
              }
            />
          </div>
        );
      },
    },
    {
      header: "Superuser",
      accessorKey: "is_superuser",
      cell: ({ row, getValue }) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <AccessControl
              children={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={false}
                  onChange={handleIsSuperUser}
                />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={
                <SwitchButton
                  id={row?.original?.id}
                  value={getValue()}
                  disabled={true}
                  onChange={handleIsSuperUser}
                />
              }
            />
          </div>
        );
      },
    },
  ];
  const filterParams = watch();
  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);
  const params = useCallback(() => {
    const newValue: any = {};
    if (filterParams.roles) {
      const groupValue = filterParams.roles?.group;
      newValue.groups = groupValue;
      // setSearchParms({
      //   groups: groupValue,
      // });
    }

    if (filterParams.user_type) {
      switch (filterParams.user_type.id) {
        case "active":
          newValue.is_active = true;
          // setSearchParms({
          //   is_active: newValue.is_active,
          // });
          break;

        case "inactive":
          newValue.is_active = false;
          // setSearchParms({
          //   is_active: newValue.is_active,
          // });
          break;

        case "staff":
          newValue.is_staff = true;
          // setSearchParms({
          //   is_staff: newValue.is_staff,
          // });
          break;

        case "superuser":
          newValue.is_superuser = true;
          // setSearchParms({
          //   is_superuser: newValue.is_superuser,
          // });
          break;
      }
    }

    return newValue;
  }, [filterParams]);
  // useEffect(() => {
  //   setSearchParms(
  //     (prev) => {
  //       const next = new URLSearchParams();

  //       Object.entries(params()).forEach(([key, value]) => {
  //         if (value !== undefined && value !== null) {
  //           next.set(key, String(value));
  //         }
  //       });

  //       return next;
  //     },
  //     { replace: true }
  //   );
  // }, [params]);

  return (
    <>
      <AccessControl allowedPermissions={["can_edit_filter"]}>
        <Card
          title="Filters"
          onClick={() => setFilterVisiable(!isFilterVisible)}
        >
          <RolesFilter
            isFilterVisible={isFilterVisible}
            register={register}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            reset={handleFilterReset}
            watch={watch}
            clearErrors={clearErrors}
            control={control}
          />
        </Card>
      </AccessControl>
      <DataTable
        url={APIS.USER}
        queryKey={"users"}
        columns={clientType === "cargo" ? defaultCargoColumns : defaultColumns}
        params={{ ...params() }}
        addNewPagePath={"/create"}
        tableName={"user-list"}
        onRowClick={handleRowClick}
      />
    </>
  );
};

export default UserList;
